import Button from '@/storybook/components/Button/Button';
import { ChevronLeftIcon } from '@/storybook/icons';
import { isBackNavigationState } from '@/types/base/navigation';
import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from './BackButton.module.css';

export const BackButton: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state } = useLocation();

  const fromName = isBackNavigationState(state) ? state.from : undefined;

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className={styles.wrapper}>
      <Button variant="text" startIcon={<ChevronLeftIcon />} className={styles.backButton} onClick={handleBack}>
        {fromName ? t('global.backTo', { pageName: fromName }) : t('global.back')}
      </Button>
    </div>
  );
};
